/**
 * Stable identity for a durable reference-video source. R2 and CDN URLs may
 * have temporary query parameters, which must not create duplicate library or
 * favorite entries for the same object.
 */
export function normalizeVideoReferenceSourceIdentity(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return "";
  try {
    const parsed = new URL(trimmed);
    parsed.hash = "";
    parsed.search = "";
    parsed.pathname = parsed.pathname.replace(/\/+$/, "") || "/";
    return parsed.toString();
  } catch {
    return trimmed.split(/[?#]/, 1)[0].replace(/\/+$/, "");
  }
}

export const VIDEO_REFERENCE_DISPLAY_NAME_MAX_LENGTH = 255;

/**
 * Normalizes a user-facing reference name without ever accepting an empty
 * label or an overlong value. The same helper is used by reads and writes so
 * display names cannot drift between library surfaces.
 */
export function normalizeVideoReferenceDisplayName(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (
    !trimmed ||
    trimmed.length > VIDEO_REFERENCE_DISPLAY_NAME_MAX_LENGTH ||
    trimmed.includes("\0")
  ) {
    return null;
  }
  return trimmed;
}